export default __webpack_public_path__ + "static/orb_icon-1eab655f9e47e5e3a6fa82a732e4623b.png";